/**
 * The barcode scanner of this tablet (T07-34): which key ends a code (most scanners: Enter; some
 * ship set to Tab) and a prefix to strip. Saved per tablet in Dexie `settings.scanner`; the scan
 * fields of the sale / offline / pickup screens read it.
 */
import { useLiveQuery } from "dexie-react-hooks";

import { usePos } from "@/app/context";
import { readSetting, writeSetting, type PosDatabase } from "@/lib/db";

export interface ScannerSettings {
  suffix: "Enter" | "Tab";
  prefix: string;
}

export const SCANNER_KEY = "scanner";
export const DEFAULT_SCANNER: ScannerSettings = { suffix: "Enter", prefix: "" };

export function readScanner(db: PosDatabase): Promise<ScannerSettings> {
  return readSetting(db, SCANNER_KEY, DEFAULT_SCANNER);
}

export function saveScanner(db: PosDatabase, settings: ScannerSettings): Promise<void> {
  return writeSetting(db, SCANNER_KEY, settings);
}

export function useScannerSettings(): ScannerSettings {
  const { db } = usePos();
  return useLiveQuery(() => readScanner(db), [db]) ?? DEFAULT_SCANNER;
}
